import { jsxs as e, jsx as l } from "react/jsx-runtime";
import { forwardRef as t } from "react";
const h = ({
  title: r,
  titleId: i,
  ...o
}, f) => /* @__PURE__ */ e("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "0 0 24 24", ref: f, "aria-labelledby": i, ...o, children: [
  r ? /* @__PURE__ */ l("title", { id: i, children: r }) : null,
  /* @__PURE__ */ l("rect", { width: 24, height: 24, fill: "#6c00f6", rx: 12 }),
  /* @__PURE__ */ l("path", { fill: "#fff", d: "m14.587 6.639-3.35 1.923v6.003l-1.847 1.07-1.859-1.071v-2.143l1.86-1.062 1.194.694v-1.734L9.38 9.634 6.032 11.58v3.848L9.39 17.36l3.348-1.934V9.425l1.859-1.072 1.858 1.072v2.133l-1.858 1.082-1.206-.7v1.726l1.195.689 3.38-1.924V8.562z" })
] }), a = t(h);
export {
  a as default
};
//# sourceMappingURL=polygon.js.map
